import result1 from "../../../../content/assets/fcn/results/1.png";
import result1gt from "../../../../content/assets/fcn/results/1gt.png";
import result1p from "../../../../content/assets/fcn/results/1p.png";
import result2 from "../../../../content/assets/fcn/results/2.png";
import result2gt from "../../../../content/assets/fcn/results/2gt.png";
import result2p from "../../../../content/assets/fcn/results/2p.png";
import result3 from "../../../../content/assets/fcn/results/3.png";
import result3gt from "../../../../content/assets/fcn/results/3gt.png";
import result3p from "../../../../content/assets/fcn/results/3p.png";
import result4 from "../../../../content/assets/fcn/results/4.png";
import result4gt from "../../../../content/assets/fcn/results/4gt.png";
import result4p from "../../../../content/assets/fcn/results/4p.png";
import result5 from "../../../../content/assets/fcn/results/5.png";
import result5gt from "../../../../content/assets/fcn/results/5gt.png";
import result5p from "../../../../content/assets/fcn/results/5p.png";
import result6 from "../../../../content/assets/fcn/results/6.png";
import result6gt from "../../../../content/assets/fcn/results/6gt.png";
import result6p from "../../../../content/assets/fcn/results/6p.png";
import result7 from "../../../../content/assets/fcn/results/7.png";
import result7gt from "../../../../content/assets/fcn/results/7gt.png";
import result7p from "../../../../content/assets/fcn/results/7p.png";
import result8 from "../../../../content/assets/fcn/results/8.png";
import result8gt from "../../../../content/assets/fcn/results/8gt.png";
import result8p from "../../../../content/assets/fcn/results/8p.png";
import result9 from "../../../../content/assets/fcn/results/9.png";
import result9gt from "../../../../content/assets/fcn/results/9gt.png";
import result9p from "../../../../content/assets/fcn/results/9p.png";
import result10 from "../../../../content/assets/fcn/results/10.png";
import result10gt from "../../../../content/assets/fcn/results/10gt.png";
import result10p from "../../../../content/assets/fcn/results/10p.png";
import Grid from "@material-ui/core/Grid";
import * as React from 'react';
export default {
  result1,
  result1gt,
  result1p,
  result2,
  result2gt,
  result2p,
  result3,
  result3gt,
  result3p,
  result4,
  result4gt,
  result4p,
  result5,
  result5gt,
  result5p,
  result6,
  result6gt,
  result6p,
  result7,
  result7gt,
  result7p,
  result8,
  result8gt,
  result8p,
  result9,
  result9gt,
  result9p,
  result10,
  result10gt,
  result10p,
  Grid,
  React
};